export const STATUS_COLORS = {
	green: '#a1cd43',
	blue: '#3b8ef3',
	yellow: '#f2c900',
	red: '#ba1818'
}
